import type { PruefungDto } from '@/shared/Pruefungen/types/pruefung.ts';
import { SharedPruefungService } from '@/shared/api/services/pruefungen.ts';

export class PruefungenService extends SharedPruefungService {
  async holePruefentscheidungenZuBuergschaftId(buergschaftId: number): Promise<PruefungDto[]> {
    return this.httpClient.get(`${this.baseUrl}/${buergschaftId}/entscheidungen`);
  }

  async pruefungLoeschen(): Promise<void> {
    throw new Error('Not implemented');
  }

  async pruefungAblehnen(): Promise<void> {
    throw new Error('Not implemented');
  }

  async istNutzerLetzterPruefer(
    id: string | number,
    type: 'auftrag' | 'buergschaft',
  ): Promise<boolean> {
    return this.httpClient.get(`${this.baseUrl}/${id.toString()}/${type}/letzter-pruefer`);
  }
}
